<template>
  <ExTable :dataSource="dataSource">
    <DxColumn caption="ID" data-field="Id"/>
    <DxColumn caption="Họ tên" data-field="FullName"/>
    <DxColumn caption="Số mua" data-field="Msisdns"/>
    <DxColumn caption="Số liên hệ" data-field="ContactPhone"/>
    <DxColumn caption="Ngày mua" data-field="CreateDate"/>
    <DxColumn caption="Nguồn" data-field="CreateFrom"/>
    <DxColumn caption="Hình thức giao hàng" data-field="DeliveryType"/>
    <DxColumn caption="Kênh thanh toán" data-field="PaymentChannel"/>
    <DxColumn caption="Giao hàng" data-field="ShippingPartner"/>
    <DxColumn caption="Tổng tiền" data-field="TotalPrice" data-type="number" format="currency"/>
  </ExTable>
</template>
<script>
import ExTable from "@/views/components/ExTable.vue";
import {DxColumn} from "devextreme-vue/data-grid";
import {$ctx} from "@themeConfig";

export default {
  components: {
    DxColumn,
    ExTable
  },
  created() {
  },
  data() {
    return {
      dataSource: {
        store: {
          type: 'odata',
          version: 4,
          url: $ctx.API_URL + 'odata.svc/Orders',
          key: 'Id',
          beforeSend: (e) => {
            e.headers = {
              'apiKey': localStorage.getItem('accessToken')
            };
          }
        },

      },
    };
  },
};
</script>
<style>
#gridContainer {
  height: 80vh;
}
</style>
